import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "field-group med-comment"
}
const _hoisted_4 = {
  key: 1,
  class: "field-group med-comment"
}
const _hoisted_5 = { class: "med-unified__row" }
const _hoisted_6 = {
  key: 2,
  class: "med-unified__sep"
}
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["aria-label", "onClick"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "med-comment__row"
}
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = {
  key: 1,
  class: "med-comment__row"
}
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = {
  key: 2,
  class: "field-group med-comment med-multi"
}
const _hoisted_15 = {
  key: 0,
  class: "med-multi__chips"
}
const _hoisted_16 = ["aria-label", "onClick"]
const _hoisted_17 = {
  key: 3,
  class: "field-group med-comment"
}
const _hoisted_18 = {
  key: 4,
  class: "field-group med-comment med-multi"
}
const _hoisted_19 = { class: "med-unified__row" }
const _hoisted_20 = { class: "med-comment__row" }
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = {
  key: 0,
  class: "med-multi__chips"
}
const _hoisted_23 = ["aria-label", "onClick"]
const _hoisted_24 = {
  key: 5,
  class: "med-msg"
}
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_mosta_tree_select = _resolveComponent("mosta-tree-select")!
  const _component_loading_skeleton = _resolveComponent("loading-skeleton")!
  const _component_recursive_selector = _resolveComponent("recursive-selector")!
  const _component_mosta_select = _resolveComponent("mosta-select")!
  const _component_multi_edit_value_row = _resolveComponent("multi-edit-value-row")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_mosta_context_menu = _resolveComponent("mosta-context-menu")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: "med-dialog-card",
    onKeydown: _ctx.windowKeyDown,
    style: _normalizeStyle(_ctx.cardSizeStyle)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, {
        class: _normalizeClass(["med-header row", { 'med-header--prompt': _ctx.isPromtDialog }])
      }, {
        default: _withCtx(() => [
          (_ctx.isPromtDialog && _ctx.isDangerAction)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.warningIcon,
                class: "med-header__icon",
                alt: ""
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([
          '',
          { 'med-header__title': _ctx.isPromtDialog },
          { 'text-subtitle2': !_ctx.isPromtDialog },
        ]),
            style: _normalizeStyle(_ctx.isPromtDialog ? '' : 'max-width: calc(100% - 30px)')
          }, _toDisplayString(_ctx.isPromtDialog ? _ctx.promptTitle : _ctx.windowTitle), 7),
          (!_ctx.isPromtDialog)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_q_space),
                _createVNode(_component_q_btn, {
                  size: "sm",
                  icon: "close",
                  class: "q-my-none unset-items-center",
                  flat: "",
                  round: "",
                  dense: "",
                  onClick: _ctx.closeItemMenu
                }, null, 8, ["onClick"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      (_ctx.isPromtDialog)
        ? (_openBlock(), _createBlock(_component_q_card_section, {
            key: 0,
            class: "med-prompt-text"
          }, {
            default: _withCtx(() => [
              (_ctx.checkingRights)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("checking_rights")), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    innerHTML: _ctx.promptTextHtml
                  }, null, 8, _hoisted_2))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.isPromtDialog)
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 1,
            class: "med-separator"
          }))
        : _createCommentVNode("", true),
      (!_ctx.isPromtDialog)
        ? (_openBlock(), _createBlock(_component_q_card_section, {
            key: 2,
            class: "scroll med-body"
          }, {
            default: _withCtx(() => [
              (_ctx.modelType === 5 && _ctx.parameterMode === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_mosta_tree_select, {
                      ref: "list_select",
                      "display-text": _ctx.listDisplayText,
                      placeholder: _ctx.$t('not_selected_label'),
                      "show-free-input": true,
                      "free-input-tooltip": _ctx.$t('create_list'),
                      "content-max-height": 360,
                      "dropdown-height": 320,
                      "onUpdate:search": _cache[3] || (_cache[3] = (val) => { _ctx.aux_filter_string = val; }),
                      onKeyDown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$refs.aux_selector && _ctx.$refs.aux_selector.trackArrowDown(1))),
                      onKeyUp: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$refs.aux_selector && _ctx.$refs.aux_selector.trackArrowUp(1))),
                      onKeyEnter: _ctx.onListSelectEnter,
                      onFreeInputPressed: _ctx.onListFreeInput
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_aux_selector, {
                          ref: "aux_selector",
                          "filter-model-value": _ctx.aux_filter_string,
                          "onUpdate:filterModelValue": _cache[0] || (_cache[0] = (arg) => { _ctx.aux_filter_string = arg; }),
                          "model-value": [],
                          "show-search-header": false,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = (arg) => { _ctx.onUpdateListModel(arg); }),
                          onInputValue: _cache[2] || (_cache[2] = (val) => { _ctx.onUpdateListModelNew(val); }),
                          "allow-free-input": true,
                          "allow-multiple": true,
                          "model-type": 17,
                          "limit-height-to-container": true,
                          "container-height-px": 240,
                          "exclude-id": _ctx.srcElement.elType == 6 ? _ctx.srcElement.Id : 0,
                          "preferred-segment": _ctx.srcElement.DestType,
                          onSelectorClosed: _ctx.hideListMenu
                        }, null, 8, ["filter-model-value", "exclude-id", "preferred-segment", "onSelectorClosed"])
                      ]),
                      _: 1
                    }, 8, ["display-text", "placeholder", "free-input-tooltip", "onKeyEnter", "onFreeInputPressed"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isUnifiedEditWindow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_mosta_tree_select, {
                        ref: "target_select",
                        class: "med-unified__target",
                        "display-text": _ctx.targetDisplayText,
                        placeholder: _ctx.$t('select_parameter'),
                        "onUpdate:search": _cache[9] || (_cache[9] = (val) => { _ctx.filter_string = val; }),
                        onKeyDown: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$refs.rec_selector && _ctx.$refs.rec_selector.trackArrowDown(1))),
                        onKeyUp: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$refs.rec_selector && _ctx.$refs.rec_selector.trackArrowUp(1))),
                        onKeyEnter: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$refs.rec_selector && _ctx.$refs.rec_selector.selectCurrent()))
                      }, {
                        default: _withCtx(() => [
                          (_ctx.canTargetDetails)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["med-unified__pinned", { 'med-unified__pinned--active': _ctx.editTarget.kind === 'details' }]),
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pickNotesTarget('details')))
                              }, _toDisplayString(_ctx.$t("details_type")), 3))
                            : _createCommentVNode("", true),
                          (_ctx.canTargetComment)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["med-unified__pinned", { 'med-unified__pinned--active': _ctx.editTarget.kind === 'comment' }]),
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pickNotesTarget('comment')))
                              }, _toDisplayString(_ctx.$t("notes_type")), 3))
                            : _createCommentVNode("", true),
                          (_ctx.canTargetParameters && (_ctx.canTargetDetails || _ctx.canTargetComment))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                            : _createCommentVNode("", true),
                          (_ctx.canTargetParameters && _ctx.parametersLoading)
                            ? (_openBlock(), _createBlock(_component_loading_skeleton, { key: 3 }))
                            : (_ctx.canTargetParameters)
                              ? (_openBlock(), _createBlock(_component_recursive_selector, {
                                  key: 4,
                                  ref: "rec_selector",
                                  elements: _ctx.parametersList,
                                  "take-ids-only": true,
                                  "show-records": true,
                                  "allow-multiple": false,
                                  "element-type": 9,
                                  modelValue: _ctx.parametersModel,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.parametersModel) = $event)),
                                  "hide-checkboxes": true,
                                  "return-type": "chain",
                                  "nested-key-name": "RecordFields",
                                  "entity-inside-name": "Template",
                                  "filter-out-list": [7],
                                  "filter-string": _ctx.filter_string
                                }, null, 8, ["elements", "modelValue", "filter-string"]))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["display-text", "placeholder"]),
                      _createVNode(_component_mosta_select, {
                        class: "med-unified__mode",
                        modelValue: _ctx.commentChangeType,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.commentChangeType) = $event)),
                        "option-label": "Name",
                        options: _ctx.changeCommentOptions,
                        disable: !_ctx.isNotesTarget
                      }, null, 8, ["modelValue", "options", "disable"])
                    ]),
                    (_ctx.editTarget.kind === 'parameter')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameterContainer ? _ctx.paramRows : [], (param_row, param_index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'pr_' + param_index,
                              class: "med-comment__row"
                            }, [
                              _createVNode(_component_multi_edit_value_row, {
                                modelValue: _ctx.paramRows[param_index],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.paramRows[param_index]) = $event),
                                "parameter-value-type": _ctx.parameterContainer.ValueType,
                                "parameter-set-value-type": 
                _ctx.parameterContainer.ValueSet
                  ? _ctx.parameterContainer.ValueSet.ValueType
                  : 0
              ,
                                "vset-type": _ctx.vsetType,
                                "vset-title": _ctx.vsetTitle,
                                vsetOptions: _ctx.vsetOptions,
                                "vset-loading": _ctx.vsetLoading
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "parameter-value-type", "parameter-set-value-type", "vset-type", "vset-title", "vsetOptions", "vset-loading"]),
                              (_ctx.isListParameter && param_index === _ctx.paramRows.length - 1)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "med-unified__row-btn",
                                    "aria-label": _ctx.$t('add_list_param_value'),
                                    onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addParamRow && _ctx.addParamRow(...args)), ["stop"]))
                                  }, [
                                    _cache[31] || (_cache[31] = _createElementVNode("svg", {
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                      _createElementVNode("path", {
                                        d: "M8 3.33333V12.6667",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round"
                                      }),
                                      _createElementVNode("path", {
                                        d: "M3.33333 8H12.6667",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round"
                                      })
                                    ], -1)),
                                    _createVNode(_component_q_tooltip, {
                                      delay: 300,
                                      anchor: "top middle",
                                      self: "bottom middle",
                                      offset: [0, 4],
                                      class: "med-tooltip"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('add_list_param_value')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_7))
                                : (_ctx.isListParameter)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "med-unified__row-btn med-unified__row-btn--del",
                                      "aria-label": _ctx.$t('delete_list_param_value'),
                                      tabindex: "-1",
                                      onClick: _withModifiers(($event: any) => (_ctx.deleteParamRow(param_index)), ["stop"])
                                    }, [
                                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "med-unified__del-ico" }, null, -1)),
                                      _createVNode(_component_q_tooltip, {
                                        delay: 300,
                                        anchor: "top middle",
                                        self: "bottom middle",
                                        offset: [0, 4],
                                        class: "med-tooltip"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('delete_list_param_value')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_8))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "med-comment__tmpl-btn",
                                      disabled: "",
                                      "aria-label": _ctx.$t('templates'),
                                      tabindex: "-1"
                                    }, _cache[33] || (_cache[33] = [
                                      _createElementVNode("span", { class: "med-comment__tmpl-ico" }, null, -1)
                                    ]), 8, _hoisted_9))
                            ]))
                          }), 128)),
                          (!_ctx.parameterContainer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_native_input, {
                                  class: "med-comment__input",
                                  style: {"width":"-webkit-fill-available"},
                                  "show-border": true,
                                  "disabled-field": true,
                                  "model-value": ''
                                }),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "med-comment__tmpl-btn",
                                  disabled: "",
                                  "aria-label": _ctx.$t('templates'),
                                  tabindex: "-1"
                                }, _cache[34] || (_cache[34] = [
                                  _createElementVNode("span", { class: "med-comment__tmpl-ico" }, null, -1)
                                ]), 8, _hoisted_11)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_native_input, {
                            ref: "comment_field",
                            class: "med-comment__input",
                            style: {"width":"-webkit-fill-available"},
                            "show-border": true,
                            "model-value": _ctx.innerNote,
                            "onUpdate:caretPosition": _ctx.onCaretPositionChange,
                            onClick: _ctx.onNativeInputClick,
                            onBlur: _ctx.onCommentBlur,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = 
              (newname) => {
                _ctx.innerNote = newname;
              }
            ),
                            "edit-on-click": true,
                            "clear-hotkey": true
                          }, null, 8, ["model-value", "onUpdate:caretPosition", "onClick", "onBlur"]),
                          _createElementVNode("button", {
                            ref: "commentTemplateBtn",
                            type: "button",
                            class: _normalizeClass(["med-comment__tmpl-btn", { 'med-comment__tmpl-btn--active': _ctx.commentTemplateMenuOpen }]),
                            "aria-label": _ctx.$t(_ctx.templatesTooltipKey),
                            onMousedown: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["prevent"])),
                            onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCommentTemplateMenu && _ctx.openCommentTemplateMenu(...args)), ["stop"]))
                          }, [
                            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "med-comment__tmpl-ico" }, null, -1)),
                            _createVNode(_component_q_tooltip, {
                              delay: 300,
                              anchor: "top middle",
                              self: "center middle",
                              class: "med-tooltip"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.templatesTooltipKey)), 1)
                              ]),
                              _: 1
                            })
                          ], 42, _hoisted_13)
                        ])),
                    _createVNode(_component_mosta_context_menu, {
                      visible: _ctx.commentTemplateMenuOpen,
                      position: _ctx.commentTemplateMenuPos,
                      "close-on-esc": true,
                      onClose: _ctx.closeCommentTemplateMenu
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "med-comment__tmpl-menu",
                          onFocusin: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(_component_aux_selector, {
                            "model-type": _ctx.commentTemplateModelType,
                            "preferred-segment": _ctx.srcElement?.DestType,
                            "input-index": 0,
                            "allow-multiple": false,
                            "allow-free-input": true,
                            onDeleteItem: _ctx.deleteCommentTemplate,
                            "onUpdate:caretPosition": _ctx.onCaretPositionChange,
                            modelValue: _ctx.comment_templates,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.comment_templates) = $event)),
                            onInputValue: _cache[19] || (_cache[19] = 
                (val) => {
                  _ctx.addCommentTemplate(val);
                }
              ),
                            onSelectorClosed: _ctx.closeCommentTemplateMenu
                          }, null, 8, ["model-type", "preferred-segment", "onDeleteItem", "onUpdate:caretPosition", "modelValue", "onSelectorClosed"])
                        ], 32)
                      ]),
                      _: 1
                    }, 8, ["visible", "position", "onClose"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.modelType === 1 && [1, 2].includes(_ctx.parameterMode))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_mosta_tree_select, {
                      ref: "tags_select",
                      "display-text": _ctx.tagsDisplayText,
                      placeholder: _ctx.$t('tags_upcase'),
                      "show-search-header": false,
                      "content-max-height": 360,
                      "dropdown-height": 320
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_aux_selector, {
                          ref: "tags_aux_selector",
                          modelValue: _ctx.tagsSelectorModel,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.tagsSelectorModel) = $event)),
                          "model-type": 1,
                          "allow-multiple": true,
                          "limit-height-to-container": true,
                          full: false,
                          "allow-free-input": true,
                          "container-height-px": 240,
                          onInputValue: _ctx.onAddFreeTag,
                          onSelectorClosed: _ctx.closeTagsSelect
                        }, null, 8, ["modelValue", "onInputValue", "onSelectorClosed"])
                      ]),
                      _: 1
                    }, 8, ["display-text", "placeholder"]),
                    (_ctx.tags.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, chip_index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'tagchip_' + chip_index,
                              class: "med-multi__chip"
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.tagChipLabel(tag)) + " ", 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "med-multi__chip-btn",
                                "aria-label": _ctx.$t('remove'),
                                tabindex: "-1",
                                onClick: _withModifiers(($event: any) => (_ctx.removeSelectedTag(chip_index)), ["stop"])
                              }, _cache[36] || (_cache[36] = [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 16 16",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M12 4L4 12",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M4 4L12 12",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round"
                                  })
                                ], -1)
                              ]), 8, _hoisted_16)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.modelType === 1 && _ctx.parameterMode === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_mosta_select, {
                        modelValue: _ctx.tagStatusModel,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.tagStatusModel) = $event)),
                        options: _ctx.tagStatusOptions,
                        "option-label": "label",
                        label: _ctx.$t('status_label')
                      }, null, 8, ["modelValue", "options", "label"])
                    ]))
                  : _createCommentVNode("", true),
              (_ctx.modelType === 15 && [1, 3].includes(_ctx.parameterMode))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_mosta_tree_select, {
                        ref: "multi_target_select",
                        class: "med-unified__target",
                        "display-text": _ctx.multipleParametersDisplayText,
                        placeholder: _ctx.$t('select_parameters'),
                        "onUpdate:search": _cache[24] || (_cache[24] = (val) => { _ctx.filter_string = val; }),
                        onKeyDown: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$refs.rec_selector && _ctx.$refs.rec_selector.trackArrowDown(1))),
                        onKeyUp: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$refs.rec_selector && _ctx.$refs.rec_selector.trackArrowUp(1))),
                        onKeyEnter: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$refs.rec_selector && _ctx.$refs.rec_selector.selectCurrent()))
                      }, {
                        default: _withCtx(() => [
                          (_ctx.parametersLoading)
                            ? (_openBlock(), _createBlock(_component_loading_skeleton, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_recursive_selector, {
                                key: 1,
                                ref: "rec_selector",
                                elements: _ctx.parametersList,
                                "take-ids-only": true,
                                "show-records": false,
                                "allow-multiple": true,
                                "element-type": 9,
                                modelValue: _ctx.multipleParametersModelChains,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.multipleParametersModelChains) = $event)),
                                "hide-checkboxes": false,
                                "return-type": "chain",
                                "nested-key-name": "RecordFields",
                                "entity-inside-name": "Template",
                                "filter-string": _ctx.filter_string
                              }, null, 8, ["elements", "modelValue", "filter-string"]))
                        ]),
                        _: 1
                      }, 8, ["display-text", "placeholder"]),
                      _createVNode(_component_mosta_select, {
                        class: "med-unified__mode",
                        modelValue: _ctx.commentChangeType,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.commentChangeType) = $event)),
                        "option-label": "Name",
                        options: _ctx.changeCommentOptions,
                        disable: true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_native_input, {
                        class: "med-comment__input",
                        style: {"width":"-webkit-fill-available"},
                        "show-border": true,
                        "disabled-field": true,
                        "model-value": ''
                      }),
                      _createElementVNode("button", {
                        type: "button",
                        class: "med-comment__tmpl-btn",
                        disabled: "",
                        "aria-label": _ctx.$t('templates'),
                        tabindex: "-1"
                      }, _cache[37] || (_cache[37] = [
                        _createElementVNode("span", { class: "med-comment__tmpl-ico" }, null, -1)
                      ]), 8, _hoisted_21)
                    ]),
                    (_ctx.multipleParametersModel.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multipleParametersModel, (param, chip_index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'chip_' + param.Id + '_' + chip_index,
                              class: "med-multi__chip"
                            }, [
                              _createTextVNode(_toDisplayString(param.Name) + " ", 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "med-multi__chip-btn",
                                "aria-label": _ctx.$t('remove'),
                                tabindex: "-1",
                                onClick: _withModifiers(($event: any) => (_ctx.removeSelectedParameter(chip_index)), ["stop"])
                              }, _cache[38] || (_cache[38] = [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 16 16",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M12 4L4 12",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M4 4L12 12",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round"
                                  })
                                ], -1)
                              ]), 8, _hoisted_23)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.msgText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.msgText), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.isPromtDialog)
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 3,
            class: "med-separator"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_card_actions, { class: "med-actions" }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "med-btn med-btn--cancel",
            ref: "cancelbtn",
            onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.closeItemMenu && _ctx.closeItemMenu(...args)))
          }, _toDisplayString(_ctx.operation_passed ? _ctx.$t("close_label") : _ctx.$t("cancel_short")), 513),
          (!_ctx.operation_passed)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["med-btn", _ctx.isDangerAction ? 'med-btn--danger' : 'med-btn--confirm']),
                ref: "okbtn",
                disabled: _ctx.checkingRights || _ctx.saveDisabled || _ctx.actionRunning || _ctx.forbidden,
                onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.performAction && _ctx.performAction(...args)))
              }, _toDisplayString(_ctx.primaryActionLabel), 11, _hoisted_25))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onKeydown", "style"]))
}